import { getOfferSubCategories } from 'redux/modules/offers/selectors';
import { offerCategorySegment } from 'redux/modules/taxonomy/selectors/offers';

const mapSubCategories = (state, props) => {
  const subCategories = getOfferSubCategories(state);
  const pathPrefix = props.location.pathname;

  const result = [];
  const { length } = subCategories;

  for (let i = 0; i < length; i += 1) {
    const category = subCategories[i];

    if (category.hiddenInNav || !category.name) {
      continue;
    }

    const categoryPath = offerCategorySegment(state, category.categoryId);

    if (!categoryPath) {
      continue;
    }

    result.push({
      name: category.name,
      hiddenInNav: category.hiddenInNav,
      search: {
        categoryId: category.categoryId,
      },
      url: `${pathPrefix}/${categoryPath}`,
    });
  }

  return result;
};

export default mapSubCategories;
